// Generated by ReScript, PLEASE EDIT WITH CARE

import Moment from "moment";

function format(stringFormat, moment) {
  return moment.format(stringFormat);
}

function moment(format, value) {
  if (format !== undefined) {
    return Moment(value, format);
  } else {
    return Moment(value);
  }
}

export {
  format ,
  moment ,
}
/* moment Not a pure module */
